<template>
  <div>
    <b-modal
      v-model="exibeModal"
      header-bg-variant="dark"
      header-text-variant="white"
      ok-title="Concluir"
      ok-only
      @ok="salvarItemFechar"
      ok-variant="secondary"
      id="modalAddItens"
      size="xl"
      title="Inserir itens no pedido"
      :hideHeaderClose="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      scrollable
      >
      <!--hide-footer-->
      <div class="m-5">
        <img v-if="produtoSelecionado.url" :src="produtoSelecionado.url" alt="" id="imgGrade">
        <img src="@/assets/sem-imagem.png" alt="" class="semImagem" v-else />
      </div>
      <b-card border-variant="light" class="shadow2 col-md-11 m-z-auto mb-3">
        <b-card-text>
          <b-row class="mb-2">
            <b-col cols="4" class="txtLeft"><b>Nome: </b> {{gradeProdutos.descricaoGrade}}</b-col>
            <b-col cols="4" class="txtLeft" v-if="!empresaKatec"><b>Item: </b>{{produtoSelecionado.codigo}}</b-col>
            <b-col cols="4" class="txtLeft" v-else><b>Código: </b>{{produtoSelecionado.codigo}}</b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col cols="4" class="txtLeft" v-if="mostraCodBarras"><b>Cód. Barras: </b>{{produtoSelecionado.ean}}</b-col>
            <b-col cols="4" class="txtLeft"><b>Estoque: </b>{{formatQtde(produtoSelecionado.estoque)}}</b-col>
            <b-col cols="4" class="txtLeft"><b>Unid.Med: </b>{{produtoSelecionado.unidMed}}</b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="txtLeft"><b>Estoque atualizado:</b> {{dateTime}}</b-col>
          </b-row>
          <b-row class="mb-2" v-if="!empresaKatec">
            <b-col class="txtLeft"><b>Descrição: </b>{{produtoSelecionado.descricao}}</b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="txtLeft col-4" v-if="!empresaKatec"><b>Previsão: </b>{{previsao.data}}</b-col>
            <b-col class="txtLeft col-4" v-else><b>Próx. Chegada: </b>{{previsao.data}}</b-col>
            <b-col class="txtLeft col-4" v-if="produtoSelecionado.foraDeLinha === 1"><b>Qtd. prevista: {{formatQtde(previsao.quantidade)}}</b></b-col>
            <b-col cols="col-4" class="txtLeft text-danger" v-if="produtoSelecionado.foraDeLinha === 1"><b>Sem Reposição</b></b-col>
          </b-row>
          <b-row class="mb-2" style="background: #eee">
            <b-col class="txtCenter"><b>{{this.tabela.descricao}}</b></b-col>
          </b-row>
        </b-card-text>
      </b-card>
      <b-row class="mb-3" v-if="tamanhos.length > 0">
        <b-col md="12" class="titleFluid"><p>MODELO</p></b-col>
      </b-row>
      <b-row class="m-z-auto col-md-11 p-0 mb-3">
        <b-form-input size="sm" placeholder="Pesquisar por descrição ou código do modelo" v-model="pesqTamanho" autocomplete="off" class="col-md-11"></b-form-input>
        <b-button class="btnLimpaFiltroRep col-md-1" size="sm" v-on:click="limparFiltroMod()"><i class="fas fa-eraser mr-2"></i></b-button>
      </b-row>
      <b-card border-variant="light" class="shadow2 col-md-11 m-z-auto mb-3">
        <b-card-text>
          <swiper :options="swiperOptionTamanhos" v-if="tamanhos.length > 0" id="sliderTamanhos">
              <swiper-slide v-for="tamanho in tamanhosFiltrados" :key="tamanho.codigoTamanho" @click.native="selecionarCores(tamanho.indexOrig, 0, '')" class="swiperSlide">
                <b-button variant="secondary" :class="tamanho.active" :disabled="disabled">{{tamanho.descricaoTamanho}}</b-button> <!--style="width: 284px;"-->
                <span v-if="tamanho.count > 0" class="countTam" :style="corEmpresa">{{tamanho.count}}</span>
              </swiper-slide>
          </swiper>
          <div class="swiper-button-prev swprBtnTamPrev" slot="button-prev"></div>
          <div class="swiper-button-next swprBtnTamNext" slot="button-next"></div>
        </b-card-text>
      </b-card>
      <b-row class="mb-3" v-if="cores.length > 0">
        <b-col md="12" class="titleFluid"><p>VARIANTE</p></b-col>
      </b-row>
      <b-row class="m-z-auto col-md-11 p-0 mb-3">
        <b-form-input size="sm" placeholder="Pesquisar por descrição, variante, código do produto ou código da variante" v-model="pesqVariante" autocomplete="off" class="col-md-11"></b-form-input>
        <b-button class="btnLimpaFiltroRep col-md-1" size="sm" v-on:click="limparFiltroVar()"><i class="fas fa-eraser mr-2"></i></b-button>
      </b-row>
      <b-card border-variant="light" class="shadow2 col-md-11 m-z-auto mb-3">
        <b-card-text>
          <swiper :options="swiperOptionVariantes" v-if="cores.length > 0">
            <swiper-slide  v-for="cor in variantesFiltradas" :key="cor.cor.codigo" @click.native="disabled === false ? selecionarProduto(cor.cor, cor.indexVarOrig, 0) : ''" class="selecionar-variante">
              <div class="img" v-if="cor.cor.url"><img :src="cor.cor.url" :class="cor.classe" alt=""/></div>
              <div class="img semImgItem" v-else><img src="@/assets/sem-imagem.png" alt="" :class="cor.classe" /></div>
              <label class="mt-4">{{cor.cor.descricaoCor}}</label>
              <span v-if="cor.count > 0" class="countTam" :style="corEmpresa">{{cor.count}}</span>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
          <div class="swiper-button-prev swprBtnVarPrev" slot="button-prev"></div>
          <div class="swiper-button-next swprBtnVarNext" slot="button-next"></div>
        </b-card-text>
      </b-card>
      <b-card border-variant="light" class="shadow2 col-md-11 m-z-auto mb-3">
        <b-card-text>
          <div  class="table"  v-if="tabelaLote">
            <b-table
              selectable
              :select-mode="selectMode"
              selectedVariant="secondary"
              @row-selected="selecionaLote"
              :fields="fields"
              :items="produtoSelecionado.lotes"
            ></b-table>
          </div>
          <div class="row" v-if="opcoesSobMedida">
            <label><b>Variante Sob Medida</b></label>
            <b-form-select v-model="itemPedido.tipoVarianteSobreMedida" :options="options" :disabled="desabilitaVariante" size="sm" class="col-md-4 ml-2 mb-3"></b-form-select>
          </div>
          <div class="">
            <div class="row">
              <div style="margin-right: 17px"  v-if="opcoesSobMedida">
                <label><b>Redondo / Oval</b></label>
                <b-form-checkbox  name="check-button" switch v-model="itemPedido.corteRedondo"  v-on:change="redondoMudaVariante">
                </b-form-checkbox>
              </div>
              <div class="mr-4 ml-1"  v-if="opcoesSobMedida">
                <label><b>Largura:</b></label>
                <b-form-input
                  type="text"
                  size="sm"
                  class="txtRight"
                  :v-on:change="calculaDimensao()"
                  v-model="itemPedido.largura"
                ></b-form-input>
                <p class="exTamSobMed text-danger">Ex.: 1 metro = 1 | 50 cm = 0.5</p>
              </div>
              <div  style="margin-left: 7px" class="mr-5"  v-if="opcoesSobMedida">
                <label><b>Comprimento:</b></label>
                <b-form-input
                  type="text"
                  size="sm"
                  class="txtRight"
                  :v-on:change="calculaDimensao()"
                  v-model="itemPedido.comprimento"
                ></b-form-input>
                <p class="exTamSobMed text-danger">Ex.: 1 metro = 1 | 50 cm = 0.5</p>
              </div>
            </div>
          </div>
          <hr>
          <b-row>
            <b-col cols="4" class="txtRight">
              <b>Preço Tabela:</b>
              <b-form-input
                size="sm"
                class="txtRight"
                disabled
                v-model="itemPedido.valorTabela"
              ></b-form-input>
            </b-col>
            <b-col cols="4" class="txtRight">
              <b>Desc.: %</b>
              <b-form-input
                type="text"
                size="sm"
                class="txtRight"
                v-on:blur="calcularTributos(1)"
                @focus="desabilitaBotao()"
                v-model.number="itemPedido.percDesconto"
              ></b-form-input>
            </b-col>
            <b-col class="txtRight">
              <b>Quantidade:</b>
              <b-form-input
                size="sm"
                class="txtRight"
                v-model="itemPedido.qtdVenda"
                v-on:blur="calcularTributos(3)"
                @focus="desabilitaBotao()"
                :disabled="this.produtoSelecionado.vendaSobMedidaM2 === 1 || this.produtoSelecionado.lotes.length > 0"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="txtRight">
              <b>Valor Unitário:</b>
              <b-form-input
                size="sm"
                v-model="itemPedido.valorUnitario"
                class="txtRight"
                v-on:blur="calcularTributos(2)"
                @focus="desabilitaBotao()"
              ></b-form-input>
            </b-col>
            <b-col cols="4" class="txtRight">
            <b>IPI:</b>
              <b-form-input
                size="sm"
                disabled
                class="txtRight"
                v-model="itemPedido.valorIPI"
              ></b-form-input>
            </b-col>
            <b-col cols="4" class="txtRight">
              <b>ICMS ST:</b>
                <b-form-input
                  size="sm"
                  disabled
                  class="txtRight"
                  v-model="itemPedido.valorICMSST"
                ></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-4 txtRight">
                <b>Valor Total:</b>
                <b-form-input
                size="sm"
                class="txtRight"
                v-model="itemPedido.totalItem"
                disabled
                ></b-form-input>
            </b-col>
            <b-col>
              <!-- <b-button variant="secondary" class="offset-9 col-3 mt-3"  v-on:click="addQtde()">Salvar Item</b-button> -->
              <b-button variant="primary" class="offset-9 col-3 mt-3" :disabled="disableButton" v-on:click="addQtde(0)" v-if="itemExistPed === 0">Adicionar Item</b-button>
              <b-button variant="primary" class="offset-9 col-3 mt-3" :disabled="disableButton" v-on:click="addQtde(1)" v-else>Editar Item</b-button>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>
      <!-- <b-row class="mb-3">
        <b-col md="11" class="titleFluid"><p>ITENS ADICIONADOS AO PEDIDO</p></b-col>
      </b-row> -->
      <!-- <b-row class="mb-3">
        <b-col md="11" class="titleFluid"><p>TOTAIS</p></b-col>
      </b-row> -->
      <!-- <b-card border-variant="light" class="shadow2 offset-1 col-md-10 mb-3">
        <div class="row">
          <b-col>
            <label><b>R$ Desconto</b></label>
            <p></p>
          </b-col>
          <b-col>
            <label><b>R$ ICMS ST</b></label>
            <p></p>
          </b-col>
          <b-col>
            <label><b>R$ IPI</b></label>
            <p></p>
          </b-col>
          <b-col>
            <label><b>R$ Total</b></label>
            <p></p>
          </b-col>
        </div>
      </b-card> -->
    </b-modal>
    <toast-vue :idToast="idToastItem" :variant="variant" :titleMsg="titleMsg" :message="message"></toast-vue>
    <BlockUI v-if="blockUiVisibility" :message="msgBlockUi">
      <spinner-vue  id="modal-xl" ></spinner-vue>
    </BlockUI>
  </div>
</template>
<script>
  import spinnerVue from '@/components/items/SpinnerVue'
  import { TheMask, mask } from 'vue-the-mask'
  // import listarPedido from '@/services/tablePedidos'
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import { broadcastServer } from '@/main'
  import pedidosServices from '@/services/tablePedidos'
  import ToastVue from '../layouts/toastVue'
  import { VMoney } from 'v-money'
  export default {
    props: {
      pedidoSelecionado: {}
    },
    name: 'modalItens',
    data () {
      return {
        empresaKatec: false,
        dateTime: '',
        mostraCodBarras: true,
        desabilitaVariante: false,
        money: {
          decimal: ',',
          thousands: '.',
          prefix: ' ',
          suffix: ' ',
          precision: 2,
          masked: false /* doesn't work with directive */
        },
        meu_valor: '0,00',
        idToastItem: 'my-toast-item',
        titleMsg: '',
        message: '',
        variant: '',
        previsao: {
          data: '',
          quantidade: ''
        },
        tabela: {},
        title: '',
        msgBlockUi: 'Salvando item do pedido, aguarde...',
        tabelaLote: false,
        quantidade: false,
        opcoesSobMedida: false,
        lotes: [],
        fields: [
          {
            isActive: true,
            label: 'Lote',
            key: 'numeroLote'
          },
          {
            isActive: true,
            label: 'SubLote',
            key: 'subLote'
          },
          {
            isActive: true,
            label: 'Quantidade',
            key: 'quantidade'
          }
        ],
        selectMode: 'multi',
        selected: null,
        options: [
          { value: 0, text: 'Por favor, selecione uma opção' },
          { value: 1, text: 'Overlock 4 lados, sem borda' },
          { value: 2, text: 'Borda virada, largura e overlock comprimento' },
          { value: 3, text: 'Borda virada nos 4 lados' }
        ],
        blockUiVisibility: false,
        detalhesItemPedido: '',
        gradeProdutos: {},
        exibeModal: false,
        tamanhos: [],
        tamanhoSelecionado: {},
        coresTamanhos: [],
        cores: [],
        corSelecionada: {},
        indiceCorSelecionada: 0,
        produtoSelecionado: {
          lotes: []
        },
        itemPedido: {
          corteRedondo: 0,
          bonificado: 0,
          numItemPedCompra: '',
          chaveErpPedido: '',
          lotes: [],
          valorICMSST: 0,
          valorTabela: 0,
          comprimento: 0,
          percDesconto: 0,
          numPedCompra: '',
          tipoVarianteSobreMedida: 0,
          codProduto: '',
          chaveErp: '',
          valorUnitario: 0,
          valorIPI: 0,
          largura: 0,
          qtdVenda: 0,
          observacao: ''
        },
        swiperOptionVariantes: {
          slidesPerView: 4,
          spaceBetween: 6,
          freeMode: true,
          navigation: {
            nextEl: '.swprBtnVarNext',
            prevEl: '.swprBtnVarPrev'
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        swiperOptionTamanhos: {
          slidesPerView: 3,
          spaceBetween: 3,
          freeMode: true,
          navigation: {
            nextEl: '.swprBtnTamNext',
            prevEl: '.swprBtnTamPrev'
          }
        },
        objToCalc: '',
        valorUnitarioSemFormat1: 0,
        valorTabelaSemFormat1: 0,
        valorIPISemFormat1: 0,
        valorICMSSTSemFormat1: 0,
        qtdVendaSemFormat1: 0,
        pedidoSelecEditar: '',
        pesqVariante: '',
        pesqTamanho: '',
        NOVO_ITEM: 0,
        EDICAO_ITEM: 1,
        indexTamSelecEdicao: 0,
        indexVarSelecEdicao: 0,
        itemExistPed: 0,
        disableButton: false
      }
      // ,disableButton: true
    },
    components: {
      ToastVue,
      swiper,
      swiperSlide,
      spinnerVue,
      TheMask,
      VMoney
    },
    directives: {
      mask,
      money: VMoney
    },
    created: function () {
      let empresa = localStorage.getItem('empresaLogada')
      if (JSON.parse(empresa).identificador === 2355480534) {
        this.empresaKatec = true
      }
      this.corEmpresa = {'background-color': `#${localStorage.getItem('corApp')}`}
      this.corEmpresa2 = `#${localStorage.getItem('corApp')}`
      broadcastServer.$on('abreModaltens', param => {
        this.carregaInfosGradeSelec(param, this.NOVO_ITEM)
        // this.disabled = false
        // this.dataHoraEstoque()
        // this.gradeProdutos = param.gradeProdutos
        // this.tabela = param.tabela
        // let tamanhos = []
        // let tamanhosGrade = param.gradeProdutos.tamanhos.sort((a, b) => (a.descricaoTamanho > b.descricaoTamanho) ? 1 : ((b.descricaoTamanho > a.descricaoTamanho) ? -1 : 0))
        // for (var iTam = 0; iTam < tamanhosGrade.length; iTam++) {
        //   let tamanho = tamanhosGrade[iTam]
        //   if (iTam === 0) {
        //     tamanhos.push({codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, active: 'active', count: 0, indexOrig: iTam})
        //     this.tamanhoSelecionado = {codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, active: 'active', count: 0, indexOrig: iTam}
        //   } else {
        //     tamanhos.push({codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, active: '', count: 0, indexOrig: iTam})
        //   }
        // }
        // this.tamanhos = tamanhos
        // this.atualizarQtdesTamanho(this.pedidoSelecionado.itens)
        // this.exibeModal = true
        // if (this.tamanhos.length > 0) {
        //   this.selecionarCores(0)
        // }
        // let empresa = localStorage.getItem('empresaLogada')
        // if (JSON.parse(empresa).identificador === 2355480534) {
        //   this.mostraCodBarras = false
        // }
      })
      broadcastServer.$on('editarItemPedido', param => {
        this.carregaInfosGradeSelec(param, this.EDICAO_ITEM)
        //   this.dataHoraEstoque()
        //   this.pedidoSelecEditar = param.itemPedido
        //   this.itemPedido = param.itemPedido
        //   this.gradeProdutos = param.gradeProdutos
        //   this.tabela = param.tabela
        //   // desabilita swipers
        //   this.disabled = true
        //   let tamanhos = []
        //   let tamanhosGrade = param.gradeProdutos.tamanhos.sort((a, b) => (a.descricaoTamanho > b.descricaoTamanho) ? 1 : ((b.descricaoTamanho > a.descricaoTamanho) ? -1 : 0))
        //   for (var iTam = 0; iTam < tamanhosGrade.length; iTam++) {
        //     let tamanho = tamanhosGrade[iTam]
        //     if (tamanho.codigoTamanho === param.itemPedido.codigoTamanho) {
        //       tamanhos.push({codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, active: 'active'})
        //       this.tamanhoSelecionado = {codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, active: 'active'}
        //     }
        //   }
        //   this.tamanhos = tamanhos

        //   // cores
        //   this.cores = []
        //   this.coresTamanhos = []
        //   let cores = this.gradeProdutos.produtos.filter(prod => prod.codigoCor === param.itemPedido.codigoCor)
        //   if (cores.length > 0) {
        //     this.produtoSelecionado = {lotes: []}
        //     this.cores.push({cor: cores[0], classe: 'imgSelecionada'})
        //     this.corSelecionada = {cor: cores[0], classe: 'imgSelecionada'}
        //     this.coresTamanhos = cores
        //     this.selecionarProduto(this.cores[0].cor, 0, 1)
        //   }
        //   this.exibeModal = true
        //   let empresa = localStorage.getItem('empresaLogada')
        //   if (JSON.parse(empresa).identificador === 2355480534) {
        //     this.mostraCodBarras = false
        //   }
      })
    },
    computed: {
      qtdVenda: {
        get: function () {
          return this.formatPrice(this.itemPedido.qtdVenda)
        },
        set: function (newValue) {
          this.itemPedido.qtdVenda = newValue
        }
      },
      variantesFiltradas () {
        return this.cores.filter(item => {
          return item.cor.codigo.toLowerCase().includes(this.pesqVariante.toLowerCase()) || item.cor.codigoCor.toLowerCase().includes(this.pesqVariante.toLowerCase()) || item.cor.descricaoCor.toLowerCase().includes(this.pesqVariante.toLowerCase()) || item.cor.descricao.toLowerCase().includes(this.pesqVariante.toLowerCase())
        })
      },
      tamanhosFiltrados () {
        // console.log(this.tamanhos.length)
        return this.tamanhos.filter(item => {
          return item.codigoTamanho.toLowerCase().includes(this.pesqTamanho.toLowerCase()) || item.descricaoTamanho.toLowerCase().includes(this.pesqTamanho.toLowerCase())
        })
      }
    },
    methods: {
      carregaInfosGradeSelec: function (param, from) {
        // console.log('carregaInfosGradeSelec começo: ' + new Date())
        this.disabled = false
        this.dataHoraEstoque()
        this.gradeProdutos = param.gradeProdutos
        this.tabela = param.tabela
        let tamanhos = []
        // let tamanhosGrade = param.gradeProdutos.tamanhos.sort((a, b) => (a.descricaoTamanho > b.descricaoTamanho) ? 1 : ((b.descricaoTamanho > a.descricaoTamanho) ? -1 : 0))
        let tamanhosGrade = [
          {
            gradeProdutos: param.gradeProdutos,
            tamanhos: param.gradeProdutos.tamanhos,
            codigoGrade: param.gradeProdutos.codigoGrade
          }
        ]
        tamanhosGrade[0].tamanhos = tamanhosGrade[0].tamanhos.sort((a, b) => (a.descricaoTamanho > b.descricaoTamanho) ? 1 : ((b.descricaoTamanho > a.descricaoTamanho) ? -1 : 0))
        // console.log('array tamanhos começo: ' + new Date())
        for (var iTam = 0; iTam < tamanhosGrade[0].tamanhos.length; iTam++) {
          let tamanho = tamanhosGrade[0].tamanhos[iTam]
          if (from === this.NOVO_ITEM) {
            if (iTam === 0) {
              tamanhos.push({codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, codigoGrade: tamanhosGrade[0].codigoGrade, active: 'active', count: 0, indexOrig: iTam})
              this.tamanhoSelecionado = {codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, codigoGrade: tamanhosGrade[0].codigoGrade, active: 'active', count: 0, indexOrig: iTam}
            } else {
              tamanhos.push({codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, codigoGrade: tamanhosGrade[0].codigoGrade, active: '', count: 0, indexOrig: iTam})
            }
          } else {
            this.indexTamSelecEdicao = tamanhosGrade[0].tamanhos.findIndex(tam => tam.codigoTamanho === param.itemPedido.codigoTamanho)
            this.tamanhoSelecionado = {codigoTamanho: param.itemPedido.codigoTamanho, descricaoTamanho: param.itemPedido.descTamanho, codigoGrade: tamanhosGrade[0].codigoGrade, active: 'active', count: 0, indexOrig: this.indexTamSelecEdicao}
            // console.log(this.indexTamSelecEdicao)
            if (iTam === this.indexTamSelecEdicao) {
              tamanhos.push({codigoTamanho: param.itemPedido.codigoTamanho, descricaoTamanho: param.itemPedido.descTamanho, codigoGrade: tamanhosGrade[0].codigoGrade, active: 'active', count: 0, indexOrig: this.indexTamSelecEdicao})
            } else {
              tamanhos.push({codigoTamanho: tamanho.codigoTamanho, descricaoTamanho: tamanho.descricaoTamanho, codigoGrade: tamanhosGrade[0].codigoGrade, active: '', count: 0, indexOrig: iTam})
            }
          }
        }
        // console.log('array tamanhos fim: ' + new Date())
        this.tamanhos = tamanhos
        this.atualizarQtdesTamanho(this.pedidoSelecionado.itens)
        this.limparFiltroMod()
        this.limparFiltroVar()
        this.exibeModal = true
        if (this.tamanhos.length > 0) {
          if (from === this.NOVO_ITEM) {
            this.selecionarCores(0, this.NOVO_ITEM, '')
          } else {
            this.selecionarCores(this.indexTamSelecEdicao, this.EDICAO_ITEM, param)
          }
        }
        let empresa = localStorage.getItem('empresaLogada')
        if (JSON.parse(empresa).identificador === 2355480534) {
          this.mostraCodBarras = false
        }
        // console.log('carregaInfosGradeSelec fim: ' + new Date())
      },
      atualizarQtdesTamanho: function (itens) {
        // console.log('atualizarQtdesTamanho começo: ' + new Date())
        // let itemTamanhoSoma = []
        // itens.reduce(function (res, value) {
        //   if (!res[value.codigoTamanho]) { // value.codigoTamanho
        //     res[value.codigoTamanho] = { codigoTamanho: value.codigoTamanho, count: 0, codigoGrade: value.codigoGrade }
        //     itemTamanhoSoma.push(res[value.codigoTamanho])
        //   }
        //   res[value.codigoTamanho].count += value.qtdVenda
        //   return res
        // }, {})
        const itemTamanhoSoma = [...itens.reduce((res, value) => {
          const key = JSON.stringify([value.codigoTamanho, value.codigoGrade])
          if (!res.has(key)) res.set(key, { codigoTamanho: value.codigoTamanho, count: 0, codigoGrade: value.codigoGrade })
          res.get(key).count += value.qtdVenda
          return res
        }, new Map()).values()]
        // console.log(itemTamanhoSoma)
        this.tamanhos.forEach(function (keyTamanho, valueTamanho) {
          itemTamanhoSoma.forEach(function (keyItem, valueItem) {
            if (keyItem.codigoTamanho === keyTamanho.codigoTamanho && keyItem.codigoGrade === keyTamanho.codigoGrade) {
              keyTamanho.count = keyItem.count
            }
          })
        })
        // console.log('atualizarQtdesTamanho fim: ' + new Date())
      },
      atualizarQtdesVariantes: function (itens) {
        // console.log('atualizarQtdesVariantes começo: ' + new Date())
        // this.cores.forEach(function (keyCor, valueCor) {
        //   itens.forEach(function (keyItemCor, valueItemCor) {
        //     // if (keyItemCor.codProduto === keyCor.cor.codigo) {
        //     if (keyItemCor.codigoTamanho === keyCor.cor.codigoTamanho && keyItemCor.codigoCor === keyCor.cor.codigoCor && keyItemCor.codProduto === keyCor.cor.codigo) {
        //       keyCor.count = keyItemCor.qtdVenda
        //     }
        //   })
        // })
        this.cores.forEach(function (keyCor, valueCor) {
          itens.forEach(function (keyItemCor, valueItemCor) {
            // if (keyItemCor.codProduto === keyCor.cor.codigo) {
            if (keyItemCor.codigoTamanho === keyCor.cor.codigoTamanho && keyItemCor.codigoCor === keyCor.cor.codigoCor && keyItemCor.codProduto === keyCor.cor.codigo) {
              keyCor.count = keyItemCor.qtdVenda
            }
          })
        })
        // console.log('atualizarQtdesVariantes fim: ' + new Date())
      },
      refreshPedido: function (objPedido) {
        // console.log('refresh começo: ' + new Date())
        this.pedido = objPedido.pedido
        // console.log('refresh fim: ' + new Date())
      },
      dataHoraEstoque: function () {
        let today = new Date()
        let date = ('0' + today.getDate()).slice(-2) + '/' + ('0' + (today.getMonth() + 1)).slice(-2) + '/' + today.getFullYear().toString().substr(-2)
        let hour = ('0' + today.getHours()).slice(-2)
        let minute = ('0' + today.getMinutes()).slice(-2)
        let seconds = ('0' + today.getSeconds()).slice(-2)
        let time = hour + ':' + minute + ':' + seconds
        this.dateTime = date + ' - ' + time
      },
      verificaFormatoValores: function () {
        if (typeof this.itemPedido.valorUnitario === 'string') {
          this.valorUnitarioSemFormat1 = parseFloat(this.itemPedido.valorUnitario.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
        } else {
          this.valorUnitarioSemFormat1 = this.itemPedido.valorUnitario
        }
        if (typeof this.itemPedido.valorDesconto === 'string') {
          this.valorDescontoSemFormat1 = parseFloat(this.itemPedido.valorDesconto.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
        } else {
          this.valorDescontoSemFormat1 = this.itemPedido.valorDesconto
        }
        if (typeof this.itemPedido.valorTabela === 'string') {
          this.valorTabelaSemFormat1 = parseFloat(this.itemPedido.valorTabela.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
        } else {
          this.valorTabelaSemFormat1 = this.itemPedido.valorTabela
        }
        if (typeof this.itemPedido.percDesconto === 'string') {
          this.percDescontoSemFormat1 = parseFloat(this.itemPedido.percDesconto.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
        } else {
          this.percDescontoSemFormat1 = this.itemPedido.percDesconto
        }
        if (typeof this.itemPedido.valorIPI === 'string') {
          this.valorIPISemFormat1 = parseFloat(this.itemPedido.valorIPI.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
        } else {
          this.valorIPISemFormat1 = this.itemPedido.valorIPI
        }
        if (typeof this.itemPedido.valorICMSST === 'string') {
          this.valorICMSSTSemFormat1 = parseFloat(this.itemPedido.valorICMSST.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
        } else {
          this.valorICMSSTSemFormat1 = this.itemPedido.valorICMSST
        }
        if (typeof this.itemPedido.qtdVenda === 'string') {
          this.qtdVendaSemFormat1 = parseFloat(this.itemPedido.qtdVenda.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
        } else {
          this.qtdVendaSemFormat1 = this.itemPedido.qtdVenda
        }
      },
      redondoMudaVariante: function () {   // Esta função está funcionando com as condições ao contrário pois o copilador está pegando o ultimo estado do switch e nao o atual
        if (this.itemPedido.corteRedondo) {
          this.desabilitaVariante = false
        } else {
          this.itemPedido.tipoVarianteSobreMedida = 1
          this.desabilitaVariante = true
        }
      },
      showMessage: function (message, title, variantColor, from) {
        console.log('from: ' + from + ' / message: ' + message)
        this.message = message
        this.titleMsg = title
        this.variant = variantColor
        this.$bvToast.show('my-toast-item')
      },
      formatPrice: function (value) {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      formatQtde: function (qtde) {
        if (typeof qtde !== 'undefined') {
          return qtde.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        }
      },
      desabilitaBotao: function () {
        this.disableButton = true
      },
      calcularTributos: function (fromInput) {
        // console.log('calcularTributos começo: ' + new Date())
        this.disableButton = false
        if (fromInput === 3) {
          fromInput = (this.produtoSelecionado.precoTabela === this.valorUnitarioSemFormat1 ? 1 : 2)
        }
        this.verificaFormatoValores()
        this.objToCalc = {
          id: this.itemPedido.id,
          idPedido: this.pedidoSelecionado.id,
          qtdVenda: this.qtdVendaSemFormat1,
          codProduto: this.itemPedido.codProduto,
          valorTabela: this.valorTabelaSemFormat1,
          percDesconto: this.percDescontoSemFormat1,
          valorUnitario: this.valorUnitarioSemFormat1,
          valorDesconto: this.valorDescontoSemFormat1,
          fromInput: fromInput
        }
        // console.log(this.objToCalc)
        this.blockUiVisibility = true
        this.msgBlockUi = 'Calculando valores, aguarde...'
        console.log(JSON.stringify(this.objToCalc))
        pedidosServices.calcularTributos(this.objToCalc).then(response => {
          console.log(JSON.stringify(response.data))
          this.itemPedido.percDesconto = response.data.percDesconto
          this.itemPedido.valorUnitario = this.formatPrice(response.data.valorUnitario)
          this.itemPedido.valorTabela = this.formatPrice(response.data.valorTabela)
          this.itemPedido.valorICMSST = this.formatPrice(response.data.valorICMSST)
          this.itemPedido.valorIPI = this.formatPrice(response.data.valorIPI)
          this.itemPedido.valorDesconto = this.formatPrice(response.data.valorDesconto)
          this.itemPedido.totalItem = this.formatPrice(response.data.totalItem)
          this.itemPedido.qtdVenda = this.formatQtde(response.data.qtdVenda)
          if (typeof response.data.valorUnitario === 'string') {
            this.valorUnitarioSemFormat1 = parseFloat(response.data.valorUnitario.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
          } else {
            this.valorUnitarioSemFormat1 = response.data.valorUnitario
          }
          // console.log('calcularTributos meio: ' + new Date())
        }).catch(error => {
          console.log(error.message)
          // this.showMessage('Aconteceu alguma coisa!' + error.message, 'Atenção', 'danger', 'calcularTributos erro')
        }).finally(() => {
          this.blockUiVisibility = false
          // console.log('calcularTributos fim: ' + new Date())
        })
      },
      selecionarCores (indiceTamanhoSelecionado, from, param) {
        // console.log('selecionarCores começo: ' + new Date())
        this.produtoSelecionado = {lotes: []}
        for (var iTam = 0; iTam < this.tamanhos.length; iTam++) {
          this.tamanhos[iTam].active = ''
          if (indiceTamanhoSelecionado === iTam) {
            this.tamanhos[iTam].active = 'active'
          }
        }
        // let tamanho = this.gradeProdutos.produtos[indiceTamanhoSelecionado]
        let tamanhosGrade = [
          {
            gradeProdutos: this.gradeProdutos,
            tamanhos: this.gradeProdutos.tamanhos,
            codigoGrade: this.gradeProdutos.codigoGrade
          }
        ]
        let tamanho = tamanhosGrade[0].gradeProdutos.tamanhos[indiceTamanhoSelecionado]
        this.tamanhoSelecionado = tamanho
        // let cores = this.gradeProdutos.produtos.filter(prod => prod.codigoTamanho === tamanho.codigoTamanho)
        let cores = tamanhosGrade[0].gradeProdutos.produtos.filter(prod => prod.codigoTamanho === tamanho.codigoTamanho)
        this.cores = []
        for (var iCor = 0; iCor < cores.length; iCor++) {
          let cor = cores[iCor]
          if (from === this.NOVO_ITEM) {
            if (iCor === 0) {
              this.cores.push({cor: cor, classe: 'imgSelecionada', codigo: cor.codigoCor, count: 0, indexVarOrig: iCor})
              this.corSelecionada = {cor: cor, classe: 'imgSelecionada', codigo: cor.codigoCor, count: 0, indexVarOrig: iCor}
            } else {
              this.cores.push({cor: cor, classe: 'imgNaoSelecionada', codigo: cor.codigoCor, count: 0, indexVarOrig: iCor})
            }
          } else {
            if (param.itemPedido.codigoCor !== '') {
              this.indexVarSelecEdicao = cores.findIndex(tam => tam.codigoCor === param.itemPedido.codigoCor)
            } else {
              this.indexVarSelecEdicao = 0
            }
            if (iCor === this.indexVarSelecEdicao) {
              this.cores.push({cor: cor, classe: 'imgSelecionada', codigo: cor.codigoCor, count: 0, indexVarOrig: this.indexVarSelecEdicao})
              this.corSelecionada = {cor: cor, classe: 'imgSelecionada', codigo: cor.codigoCor, count: 0, indexVarOrig: this.indexVarSelecEdicao}
            } else {
              this.cores.push({cor: cor, classe: 'imgNaoSelecionada', codigo: cor.codigoCor, count: 0, indexVarOrig: iCor})
            }
          }
        }
        this.coresTamanhos = cores
        this.atualizarQtdesVariantes(this.pedidoSelecionado.itens)
        if (this.cores.length > 0) {
          if (from === this.NOVO_ITEM) {
            this.selecionarProduto(this.cores[0].cor, 0, 0)
          } else {
            this.selecionarProduto(this.corSelecionada.cor, this.indexVarSelecEdicao, 0)
          }
        }
        // console.log('selecionarCores fim: ' + new Date())
      },
      selecionarProduto (corSelecionada, indiceCorSelecionada, from) {
        // console.log('selec produto começo: ' + new Date())
        this.dataHoraEstoque()
        this.produtoSelecionado = {lotes: []}
        this.corSelecionada = corSelecionada
        this.indiceCorSelecionada = indiceCorSelecionada
        for (var iCor = 0; iCor < this.cores.length; iCor++) {
          this.cores[iCor].classe = 'imgNaoSelecionada'
          if (indiceCorSelecionada === iCor) {
            this.cores[iCor].classe = 'imgSelecionada'
          }
        }
        let produtos = this.gradeProdutos.produtos.filter(prod => prod.codigoTamanho === this.tamanhoSelecionado.codigoTamanho && prod.codigoCor === corSelecionada.codigoCor)
        if (produtos.length > 0) {
          this.produtoSelecionado = produtos[0]
          let itemExistPed = this.pedidoSelecionado.itens.filter(function (item) {
            return item.codProduto === produtos[0].codigo
          })
          if (itemExistPed.length > 0) {
            this.itemExistPed = 1
          } else {
            this.itemExistPed = 0
          }
          this.previsao.data = (this.produtoSelecionado.previsao.length === 0 ? 'Sem Previsão' : this.produtoSelecionado.previsao[0].dataPrevisao)
          this.previsao.quantidade = (this.produtoSelecionado.previsao.length === 0 ? '' : this.produtoSelecionado.previsao[0].quantidade)
          if (this.produtoSelecionado.vendaSobMedidaM2 === 1) {
            this.opcoesSobMedida = true
            this.tabelaLote = false
            this.quantidade = false
          } else if (this.produtoSelecionado.lotes.length > 0) {
            this.tabelaLote = true
            this.quantidade = false
            this.opcoesSobMedida = false
          } else {
            this.tabelaLote = false
            this.quantidade = true
            this.opcoesSobMedida = false
          }
          if (from === 0) {
            this.novoItemPedido()
            this.valorUnitarioSemFormat1 = this.itemPedido.valorUnitario
            this.valorTabelaSemFormat1 = this.itemPedido.valorTabela
            this.percDescontoSemFormat1 = this.itemPedido.percDesconto
            let produtoSelecionado = this.produtoSelecionado
            // let itemSelecPedido = this.pedidoSelecionado.itens.filter(item => item.codProduto === this.produtoSelecionado.codigo)
            // let itemSelecPedido = this.pedidoSelecionado.itens.filter(item => item.codigoTamanho === this.produtoSelecionado.codigoTamanho && item.codigoCor === this.produtoSelecionado.codigoCor)
            let itemSelecPedido = this.pedidoSelecionado.itens.filter(function (item) {
              return item.codigoTamanho === produtoSelecionado.codigoTamanho && item.codigoCor === produtoSelecionado.codigoCor && item.codProduto === produtoSelecionado.codigo
            })
            itemSelecPedido = itemSelecPedido[0]
            if (itemSelecPedido) {
              this.itemPedido.id = itemSelecPedido.id
              this.itemPedido.corteRedondo = itemSelecPedido.corteRedondo
              this.itemPedido.bonificado = itemSelecPedido.bonificado
              this.itemPedido.numItemPedCompra = itemSelecPedido.numItemPedCompra
              this.itemPedido.lotes = itemSelecPedido.lotes
              this.itemPedido.valorICMSST = this.formatPrice(itemSelecPedido.valorICMSST)
              this.itemPedido.valorTabela = this.formatPrice(itemSelecPedido.valorTabela)
              this.itemPedido.comprimento = itemSelecPedido.comprimento
              this.itemPedido.percDesconto = itemSelecPedido.percDesconto
              this.itemPedido.numPedCompra = itemSelecPedido.numPedCompra
              this.itemPedido.tipoVarianteSobreMedida = itemSelecPedido.tipoVarianteSobreMedida
              this.itemPedido.codProduto = itemSelecPedido.codProduto
              this.itemPedido.valorUnitario = this.formatPrice(itemSelecPedido.valorUnitario)
              this.itemPedido.valorIPI = this.formatPrice(itemSelecPedido.valorIPI)
              this.itemPedido.valorDesconto = this.formatPrice(itemSelecPedido.valorDesconto)
              this.itemPedido.valorBruto = this.formatPrice(itemSelecPedido.valorBruto)
              this.itemPedido.percentualIpi = itemSelecPedido.percentualIpi
              this.itemPedido.valorLiquido = this.formatPrice(itemSelecPedido.valorLiquido)
              this.itemPedido.descTamanho = this.formatPrice(itemSelecPedido.descTamanho)
              this.itemPedido.totalItem = this.formatPrice(itemSelecPedido.totalItem)
              this.itemPedido.largura = itemSelecPedido.largura
              this.itemPedido.qtdVenda = itemSelecPedido.qtdVenda
              // console.log(this.itemPedido)
            }
            this.calcularTributos(1)
          } else {
            let paramPerc = (this.produtoSelecionado.precoTabela === this.pedidoSelecEditar.valorUnitario ? 1 : 2)
            this.valorUnitarioSemFormat1 = this.pedidoSelecEditar.valorUnitario
            this.valorTabelaSemFormat1 = this.pedidoSelecEditar.valorTabela
            this.percDescontoSemFormat1 = this.pedidoSelecEditar.percDesconto
            let itemSelecPedido = this.pedidoSelecionado.itens.filter(item => item.codProduto === this.produtoSelecionado.codigo)
            itemSelecPedido = itemSelecPedido[0]
            if (itemSelecPedido) {
              this.itemPedido.id = itemSelecPedido.id
              this.itemPedido.corteRedondo = itemSelecPedido.corteRedondo
              this.itemPedido.bonificado = itemSelecPedido.bonificado
              this.itemPedido.numItemPedCompra = itemSelecPedido.numItemPedCompra
              this.itemPedido.lotes = itemSelecPedido.lotes
              this.itemPedido.valorICMSST = this.formatPrice(itemSelecPedido.valorICMSST)
              this.itemPedido.valorTabela = this.formatPrice(itemSelecPedido.valorTabela)
              this.itemPedido.comprimento = itemSelecPedido.comprimento
              this.itemPedido.percDesconto = itemSelecPedido.percDesconto
              this.itemPedido.numPedCompra = itemSelecPedido.numPedCompra
              this.itemPedido.tipoVarianteSobreMedida = itemSelecPedido.tipoVarianteSobreMedida
              this.itemPedido.codProduto = itemSelecPedido.codProduto
              this.itemPedido.valorUnitario = this.formatPrice(itemSelecPedido.valorUnitario)
              this.itemPedido.valorIPI = this.formatPrice(itemSelecPedido.valorIPI)
              this.itemPedido.valorDesconto = this.formatPrice(itemSelecPedido.valorDesconto)
              this.itemPedido.valorBruto = this.formatPrice(itemSelecPedido.valorBruto)
              this.itemPedido.percentualIpi = itemSelecPedido.percentualIpi
              this.itemPedido.valorLiquido = this.formatPrice(itemSelecPedido.valorLiquido)
              this.itemPedido.descTamanho = this.formatPrice(itemSelecPedido.descTamanho)
              this.itemPedido.totalItem = this.formatPrice(itemSelecPedido.totalItem)
              this.itemPedido.largura = itemSelecPedido.largura
              this.itemPedido.qtdVenda = itemSelecPedido.qtdVenda
              // console.log(this.itemPedido)
            }
            this.calcularTributos(paramPerc)
          }
        }
        // console.log('selec produto fim: ' + new Date())
      },
      atualizarItensPedido (corSelecionada, indiceCorSelecionada, from) {
        // console.log('atualizar produto começo: ' + new Date())
        this.produtoSelecionado = {lotes: []}
        this.corSelecionada = corSelecionada
        this.indiceCorSelecionada = indiceCorSelecionada
        for (var iCor = 0; iCor < this.cores.length; iCor++) {
          this.cores[iCor].classe = 'imgNaoSelecionada'
          if (indiceCorSelecionada === iCor) {
            this.cores[iCor].classe = 'imgSelecionada'
          }
        }
        let produtos = this.gradeProdutos.produtos.filter(prod => prod.codigoTamanho === this.tamanhoSelecionado.codigoTamanho && prod.codigoCor === corSelecionada.codigoCor)
        if (produtos.length > 0) {
          this.produtoSelecionado = produtos[0]
          let itemExistPed = this.pedido.itens.filter(function (item) {
            return item.codProduto === produtos[0].codigo
          })
          if (itemExistPed.length > 0) {
            this.itemExistPed = 1
          } else {
            this.itemExistPed = 0
          }
          this.previsao.data = (this.produtoSelecionado.previsao.length === 0 ? 'Sem Previsão' : this.produtoSelecionado.previsao[0].dataPrevisao)
          this.previsao.quantidade = (this.produtoSelecionado.previsao.length === 0 ? '' : this.produtoSelecionado.previsao[0].quantidade)
          if (this.produtoSelecionado.vendaSobMedidaM2 === 1) {
            this.opcoesSobMedida = true
            this.tabelaLote = false
            this.quantidade = false
          } else if (this.produtoSelecionado.lotes.length > 0) {
            this.tabelaLote = true
            this.quantidade = false
            this.opcoesSobMedida = false
          } else {
            this.tabelaLote = false
            this.quantidade = true
            this.opcoesSobMedida = false
          }
          if (from === 0) {
            this.novoItemPedido()
            this.valorUnitarioSemFormat1 = this.itemPedido.valorUnitario
            this.valorTabelaSemFormat1 = this.itemPedido.valorTabela
            this.percDescontoSemFormat1 = this.itemPedido.percDesconto
            let produtoSelecionado = this.produtoSelecionado
            // let itemSelecPedido = this.pedidoSelecionado.itens.filter(item => item.codProduto === this.produtoSelecionado.codigo)
            // let itemSelecPedido = this.pedido.itens.filter(item => item.codigoTamanho === this.produtoSelecionado.codigoTamanho && item.codigoCor === this.produtoSelecionado.codigoCor)
            let itemSelecPedido = this.pedido.itens.filter(function (item) {
              return item.codigoTamanho === produtoSelecionado.codigoTamanho && item.codigoCor === produtoSelecionado.codigoCor && item.codProduto === produtoSelecionado.codigo
            })
            itemSelecPedido = itemSelecPedido[0]
            if (itemSelecPedido) {
              this.itemPedido.id = itemSelecPedido.id
              this.itemPedido.corteRedondo = itemSelecPedido.corteRedondo
              this.itemPedido.bonificado = itemSelecPedido.bonificado
              this.itemPedido.numItemPedCompra = itemSelecPedido.numItemPedCompra
              this.itemPedido.lotes = itemSelecPedido.lotes
              this.itemPedido.valorICMSST = this.formatPrice(itemSelecPedido.valorICMSST)
              this.itemPedido.valorTabela = this.formatPrice(itemSelecPedido.valorTabela)
              this.itemPedido.comprimento = itemSelecPedido.comprimento
              this.itemPedido.percDesconto = itemSelecPedido.percDesconto
              this.itemPedido.numPedCompra = itemSelecPedido.numPedCompra
              this.itemPedido.tipoVarianteSobreMedida = itemSelecPedido.tipoVarianteSobreMedida
              this.itemPedido.codProduto = itemSelecPedido.codProduto
              this.itemPedido.valorUnitario = this.formatPrice(itemSelecPedido.valorUnitario)
              this.itemPedido.valorIPI = this.formatPrice(itemSelecPedido.valorIPI)
              this.itemPedido.largura = itemSelecPedido.largura
              this.itemPedido.qtdVenda = itemSelecPedido.qtdVenda
              // console.log(this.itemPedido)
            }
            this.calcularTributos(1)
          } else {
            let paramPerc = (this.produtoSelecionado.precoTabela === this.pedidoSelecEditar.valorUnitario ? 1 : 2)
            this.valorUnitarioSemFormat1 = this.pedidoSelecEditar.valorUnitario
            this.valorTabelaSemFormat1 = this.pedidoSelecEditar.valorTabela
            this.percDescontoSemFormat1 = this.pedidoSelecEditar.percDesconto
            let itemSelecPedido = this.pedido.itens.filter(item => item.codProduto === this.produtoSelecionado.codigo)
            itemSelecPedido = itemSelecPedido[0]
            if (itemSelecPedido) {
              this.itemPedido.id = itemSelecPedido.id
              this.itemPedido.corteRedondo = itemSelecPedido.corteRedondo
              this.itemPedido.bonificado = itemSelecPedido.bonificado
              this.itemPedido.numItemPedCompra = itemSelecPedido.numItemPedCompra
              this.itemPedido.lotes = itemSelecPedido.lotes
              this.itemPedido.valorICMSST = this.formatPrice(itemSelecPedido.valorICMSST)
              this.itemPedido.valorTabela = this.formatPrice(itemSelecPedido.valorTabela)
              this.itemPedido.comprimento = itemSelecPedido.comprimento
              this.itemPedido.percDesconto = itemSelecPedido.percDesconto
              this.itemPedido.numPedCompra = itemSelecPedido.numPedCompra
              this.itemPedido.tipoVarianteSobreMedida = itemSelecPedido.tipoVarianteSobreMedida
              this.itemPedido.codProduto = itemSelecPedido.codProduto
              this.itemPedido.valorUnitario = this.formatPrice(itemSelecPedido.valorUnitario)
              this.itemPedido.valorIPI = this.formatPrice(itemSelecPedido.valorIPI)
              this.itemPedido.largura = itemSelecPedido.largura
              this.itemPedido.qtdVenda = itemSelecPedido.qtdVenda
              // console.log(this.itemPedido)
            }
            this.calcularTributos(paramPerc)
          }
        }
        // console.log('atualizar produto fim: ' + new Date())
      },
      selecionaLote: function (lotes) {
        let qtdeLotes = 0
        for (var i = 0; i < lotes.length; i++) {
          qtdeLotes += lotes[i].quantidade
        }
        this.itemPedido.qtdVenda = qtdeLotes
        this.itemPedido.lotes = lotes
      },
      novoItemPedido: function () {
        // console.log('novoItemPedido começo: ' + new Date())
        this.itemPedido = {
          id: 0,
          idPedido: 0,
          corteRedondo: 0,
          bonificado: 0,
          numItemPedCompra: '',
          chaveErpPedido: '',
          lotes: [],
          valorICMSST: 0,
          valorTabela: 0,
          comprimento: undefined,
          percDesconto: 0,
          numPedCompra: '',
          tipoVarianteSobreMedida: 0,
          codProduto: '',
          chaveErp: '',
          valorUnitario: 0,
          valorIPI: 0,
          valorDesconto: 0,
          valorBruto: 0,
          percentualIpi: 0,
          valorLiquido: 0,
          descTamanho: 0,
          totalItem: 0,
          largura: undefined,
          qtdVenda: 1,
          observacao: '',
          codTabelaPreco: '',
          clienteNovo: 0
        }
        this.itemPedido.valorTabela = this.produtoSelecionado.precoTabela
        this.itemPedido.tipoVarianteSobreMedida = 0
        this.itemPedido.codProduto = this.produtoSelecionado.chaveErp
        this.itemPedido.chaveErp = ''
        this.itemPedido.valorUnitario = this.produtoSelecionado.precoTabela
        this.itemPedido.valorIPI = 0.00
        this.itemPedido.largura = 0.00
        this.itemPedido.qtdVenda = 1.00
        if (this.produtoSelecionado.vendaSobMedidaM2 === 1 || this.produtoSelecionado.lotes.length > 0) {
          this.itemPedido.qtdVenda = 0.00
        }
        let empresa = localStorage.getItem('empresaLogada')
        if (JSON.parse(empresa).identificador === 224262964110) {
          console.log('empresa -> ' + empresa)
          this.itemPedido.tipoVarianteSobreMedida = 1
        } else if (JSON.parse(empresa).identificador === 67365910546) {
          this.itemPedido.tipoVarianteSobreMedida = 2
        } else {
          this.itemPedido.tipoVarianteSobreMedida = 0
        }
        // console.log('novoItemPedido fim: ' + new Date())
      },
      // calculaTotalItem: function () {
      //   this.itemPedido.totalItem = this.formatPrice((this.itemPedido.qtdVenda * this.valorUnitarioSemFormat1))
      // },
      calculaDimensao: function () {
        if (this.itemPedido.largura === '' || typeof this.itemPedido.largura === 'undefined') {
          this.itemPedido.largura = 0
        }
        if (this.itemPedido.comprimento === '' || typeof this.itemPedido.comprimento === 'undefined') {
          this.itemPedido.comprimento = 0
        }

        if (typeof this.itemPedido.largura !== 'number') {
          if (this.itemPedido.largura.includes(',')) {
            this.itemPedido.largura = this.itemPedido.largura.replace(/,/g, '.')
          }
        }
        if (typeof this.itemPedido.comprimento !== 'number') {
          if (this.itemPedido.comprimento.includes(',')) {
            this.itemPedido.comprimento = this.itemPedido.comprimento.replace(/,/g, '.')
          }
        }
        let largura = parseFloat(this.itemPedido.largura)
        let comprimento = parseFloat(this.itemPedido.comprimento)
        if (this.itemPedido.tipoVarianteSobreMedida === 2) {
          comprimento += 0.1
        } else if (this.itemPedido.tipoVarianteSobreMedida === 3) {
          largura += 0.1
          comprimento += 0.1
        }

        this.itemPedido.qtdVenda = (largura * comprimento).toFixed(2)
      },
      salvarItemFechar: function () {
        let param = 1
        broadcastServer.$emit('fechaModalItens', param)
        this.exibeModal = false
        this.limparFiltroMod()
        this.limparFiltroVar()
        this.selecionarProduto(this.corSelecionada, this.indiceCorSelecionada, 0)
      },
      addQtde: function (from) {
        if (typeof this.itemPedido.qtdVenda === 'string') {
          this.itemPedido.qtdVenda = parseFloat(this.itemPedido.qtdVenda.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
          if (this.itemPedido.qtdVenda === 0) {
            this.showMessage('É necessário que seja adicionado pelo menos um item antes de salvar.', 'Atenção', 'warning', 'addQtde if qtdVenda')
            return
          }
        } else {
          if (this.itemPedido.qtdVenda === 0) {
            this.showMessage('É necessário que seja adicionado pelo menos um item antes de salvar.', 'Atenção', 'warning', 'addQtde else qtdVenda')
            return
          }
        }
        if (this.itemPedido.qtdVenda === '' || typeof this.itemPedido.qtdVenda === 'undefined') {
          this.itemPedido.qtdVenda = 1
        }
        if (this.produtoSelecionado.foraDeLinha === 1 && this.produtoSelecionado.estoque <= 0) {
          this.showMessage('Produto fora de linha e/ou estoque indisponível, não será possível adicionar este produto ao pedido.', 'Atenção', 'warning', 'addQtde foraDeLinha 1')
          return
        }
        if (this.produtoSelecionado.foraDeLinha === 1 && (this.produtoSelecionado.estoque < this.itemPedido.qtdVenda)) {
          console.log('é menor')
          this.showMessage('Quantidade de itens adicionada não disponível em estoque. Verifique a quantidade antes de continuar.', 'Atenção', 'danger', 'addQtde foraDeLinha 2')
          return
        }
        if (this.produtoSelecionado.vendaSobMedidaM2 === 1 && this.itemPedido.tipoVarianteSobreMedida === 0) {
          this.showMessage('Selecione a variante sob Medida.', 'Atenção', 'warning', 'addQtde vendaSobMedidaM2')
          return
        }
        if (this.itemPedido.largura === '' || typeof this.itemPedido.largura === 'undefined') {
          this.itemPedido.largura = 0
        }
        if (this.itemPedido.comprimento === '' || typeof this.itemPedido.comprimento === 'undefined') {
          this.itemPedido.comprimento = 0
        }
        if (this.produtoSelecionado.vendaSobMedidaM2 === 1) {
          if (this.itemPedido.comprimento < this.itemPedido.largura) {
            this.showMessage('Comprimento não pode ser menor que a largura.', 'Atenção', 'warning', 'addQtde vendaSobMedidaM2 > comprimento')
            return
          }
        }
        let percLimiteDescontoRepresentante = 0.00
        let dadosAcesso = JSON.parse(localStorage.getItem('dadosAcesso'))
        percLimiteDescontoRepresentante = dadosAcesso.representante.percLimiteDesconto
        if (percLimiteDescontoRepresentante === '' || typeof percLimiteDescontoRepresentante === 'undefined') {
          percLimiteDescontoRepresentante = 0
        }
        if (this.itemPedido.percDesconto > percLimiteDescontoRepresentante) {
          this.showMessage('Percentual de desconto não permitido acima de: ' + percLimiteDescontoRepresentante + '%', 'Atenção', 'warning', 'addQtde percDesconto')
          return
        }
        this.itemPedido.idPedido = this.pedidoSelecionado.id
        this.itemPedido.chaveErpPedido = this.pedidoSelecionado.chaveErp
        this.itemPedido.codProduto = this.produtoSelecionado.codigo
        this.itemPedido.codTabelaPreco = this.pedidoSelecionado.tabelaPreco.codigo
        if (typeof this.itemPedido.valorTabela === 'string') {
          this.itemPedido.valorTabela = parseFloat(this.itemPedido.valorTabela.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
        }
        if (typeof this.itemPedido.valorUnitario === 'string') {
          this.itemPedido.valorUnitario = parseFloat(this.itemPedido.valorUnitario.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
        }
        if (typeof this.itemPedido.valorDesconto === 'string') {
          this.itemPedido.valorDesconto = parseFloat(this.itemPedido.valorDesconto.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
        }
        if (typeof this.itemPedido.percDesconto === 'string') {
          this.itemPedido.percDesconto = parseFloat(this.itemPedido.percDesconto.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
        }
        if (typeof this.itemPedido.totalItem === 'string') {
          this.itemPedido.totalItem = parseFloat(this.itemPedido.totalItem.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
        }
        if (typeof this.itemPedido.qtdVenda === 'string') {
          this.itemPedido.qtdVenda = parseFloat(this.itemPedido.qtdVenda.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
        }
        if (typeof this.itemPedido.valorICMSST === 'string') {
          this.itemPedido.valorICMSST = parseFloat(this.itemPedido.valorICMSST.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
        }
        if (typeof this.itemPedido.valorIPI === 'string') {
          this.itemPedido.valorIPI = parseFloat(this.itemPedido.valorIPI.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
        }
        // this.itemPedido.clienteNovo = this.pedidoSelecionado.cliente.clienteNovo
        this.blockUiVisibility = true
        this.msgBlockUi = 'Salvando item do pedido, aguarde...'
        pedidosServices.inserirPedidoItem(this.itemPedido).then(response => {
          let objPedido = { pedido: response.data.pedido, condPagtos: response.data.condPagtos }
          broadcastServer.$emit('refreshPedido', objPedido)
          this.refreshPedido(objPedido)
          // console.log(this.pedidoSelecionado.itens)
          this.atualizarQtdesTamanho(this.pedido.itens)
          this.atualizarQtdesVariantes(this.pedido.itens)
          // let param = 1
          // broadcastServer.$emit('fechaModalItens', param)
          // this.exibeModal = false
          this.atualizarItensPedido(this.corSelecionada, this.indiceCorSelecionada, 0)
          if (from === 0) {
            this.showMessage('Produto incluído com sucesso', 'Sucesso', 'success', 'addItem inserirPedido ok')
          } else {
            this.showMessage('Produto alterado com sucesso', 'Sucesso', 'success', 'addItem inserirPedido ok')
          }
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'addQtde inserirPedidoItem erro')
        }).finally(() => {
          this.blockUiVisibility = false
        })
      },
      rowSelected (fields) {
        this.selected = fields
      },
      onSlideStart (index) {
        let descricao = this.destaques[index].descricao
        this.descricao = descricao
      },
      onSlideEnd (index) {
        let descricao = this.destaques[index].descricao
        this.descricao = descricao
      },
      limparFiltroMod: function () {
        this.pesqTamanho = ''
      },
      limparFiltroVar: function () {
        this.pesqVariante = ''
      }
      // ,
      // detalhesItem: function () {
      //   broadcastServer.$on('detalhesItem', detalhes => {
      //     this.detalhesItemPedido = detalhes
      //     console.log(detalhes)
      //   })
      // }
    }
    // mounted () {
    //   dashboard.listarDashboard().then(response => {
    //     this.destaques = response.data.destaques
    //   })
    // }
  }
</script>
<style scoped>
  .btn-circle {
    width: 30px;
    height: 30px;
    padding: 6px 0px;
    border-radius: 25px;
    text-align: center;
    font-size: 12px;
    line-height: 1.42857;
    margin-top: 32px;
  }
  .swiperSlide .btn-secondary:not(:disabled):not(.disabled).active,
  .swiperSlide .btn-secondary:not(:disabled):not(.disabled):active,
  .swiperSlide .show>.btn-secondary.dropdown-toggle,
  .swiperSlide .btn-secondary:hover {
    background-color: #252b31 !important;
    border-color: #252b31 !important;
  }
  #imgGrade {
    max-width: 300px;
    max-height: 200px;
    box-shadow: 5px 10px 20px 0px rgba(183, 183, 183, 0.75);
  }
  .img {
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }
  .img img {
    max-width: 100%;
    display: block;
  }
  .semImagem {
    max-width: 100%;
    max-height: 80px;
  }
  .semImgItem {
    max-width: 100%;
  }
  .semImgItem img {
    max-width: 100%;
    padding: 0 10px;
  }
  .imgSelecionada {
    max-height: 150px;
    box-shadow: 5px 15px 20px 0px rgba(23, 23, 23, 0.75);
  }
  .imgNaoSelecionada {
    max-height: 110px;
    box-shadow: 5px 10px 20px 0px rgba(183, 183, 183, 0.75);
  }
  .table {
    overflow-y: scroll;
    position: relative;
    max-height: 200px;
    font-size: 14px;
  }
  /* .selecionar-variante {
    height: 225px;
  } */
  /* .swiper-slide {
    width: auto !important;
    margin-right: 3px
  } */
  /* #sliderTamanhos .swiper-slide {
    margin-right: 3px;
    width: auto !important;
  } */
  .swiper-pagination {
    position: relative !important;
    bottom: 0 !important;
  }
  /*.card-text{*/
    /*padding: 1.25rem 30px;*/
  /*}*/
  .exTamSobMed {
    font-size: 11px;
    margin-top: 2px;
  }
  .custom-switch {
    padding-right: 1.8rem;
  }
  .countTam {
    position: absolute;
    z-index: 99;
    color: #fff;
    top: 2px;
    right: 2px;
    padding: 5px 9px;
    border-radius: 50%;
    line-height: 14px;
    font-size: 14px;
  }
  .titleFluid:before {
    width: 87%;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/modalAddItensVue.vue